/**
 * Service-worker registration.
 *
 * Only in a production build, and only where the browser supports it. In `pnpm dev` a
 * service worker intercepts vite's module graph and hot reload stops working in ways
 * that look like a compiler bug — so dev actively UNREGISTERS any worker left behind
 * by someone who ran a production build on the same origin once. That stale worker
 * outlives the build that installed it and is invisible until you go looking for it.
 */

export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return

  if (!import.meta.env.PROD) {
    void navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        for (const registration of registrations) void registration.unregister()
      })
      .catch(() => undefined)
    return
  }

  // After `load`: registration competes with the first render for the network, and the
  // first render is what the user is waiting for.
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {
      // A failed registration costs the install prompt and the offline start, and
      // nothing else. It must never surface as an error to a dispatcher mid-shift.
    })
  })
}
